import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Sunrise, Sunset } from 'lucide-react';

function ChecklistsHome({ user }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-white to-primary/5">
      <header className="glass border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/')}
            data-testid="back-button"
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex-1">
            <h1 className="font-bold text-lg text-gray-900">Daily Checklists</h1>
            <p className="text-xs text-gray-500">Opening and closing procedures</p>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            onClick={() => navigate('/checklist/opening')}
            data-testid="opening-checklist-option"
            className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-100 hover:border-primary/30 hover-lift cursor-pointer"
          >
            <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-orange-500 to-yellow-400 flex items-center justify-center mb-4">
              <Sunrise className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Opening Checklist</h2>
            <p className="text-gray-600">Complete tasks to open the store</p>
          </div>

          <div
            onClick={() => navigate('/checklist/closing')}
            data-testid="closing-checklist-option"
            className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-100 hover:border-primary/30 hover-lift cursor-pointer"
          >
            <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-indigo-600 to-purple-500 flex items-center justify-center mb-4">
              <Sunset className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Closing Checklist</h2>
            <p className="text-gray-600">Complete tasks to close the store</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ChecklistsHome;